<!-- eslint-disable vue/no-v-html -->
<template>
  <UModal
    v-model:open="is_open"
    fullscreen
    :title="t('salesTerms.title')"
  >
    <template #body>
      <div
        v-if="data"
        class="external-page"
        v-html="data"
      />
      <div v-else>
        <p v-text="t('privacyPolicy.errorMessage', { website })" />
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
const is_open = useState<boolean>('showSalesTermsModal')

const { ngo: { website } } = getData().data

const { api_endpoint } = useRuntimeConfig().public
const { data } = useFetch<HTMLElement>(`${api_endpoint}/sales-terms`)

defineProps({
  btnLabel: {
    type: String,
    default: 'Salgsbetingelser',
  },
  btnClass: {
    type: String,
    default: '',
  },
})

defineShortcuts({
  escape: {
    usingInput: true,
    handler: () => {
      is_open.value = false
    },
  },
})
</script>

<style>
.external-page p,
.external-page ul {
  margin-bottom: 1rem;
}
.external-page ul {
  list-style-type: disc;
  padding-left: 2rem;
}

.external-page h1 {
  font-size: 1.8rem;
}
.external-page h2 {
  font-size: 1.4rem;
}
</style>
